var map = {
	"./_module_demo_/client/graphql/settings": 86729,
	"./kitchen-order-ticket/client/graphql/settings": 99049,
	"./menu-management/client/graphql/settings": 36071,
	"./sport-hub/client/graphql/settings": 31174,
	"./waitress-order-ticket/client/graphql/settings": 92110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9381;